import callAPiBase from './base';

const orderSchoolsApi = {
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolCreateChargeRequest',
      method: 'POST',
      useToken: true,
      title: 'Order - Create',
      data,
    }),
  repeat: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/schoolRepeatChargeRequest',
      method: 'POST',
      useToken: true,
      title: 'Order - Repeat',
      data,
    }),
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schoolListChargeRequests',
      method: 'GET',
      useToken: true,
      title: 'Orders - Get/List',
      params,
    }),
  deleteChargeRequest: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/schoolDeleteChargeRequest',
      method: 'DELETE',
      useToken: true,
      title: 'Orders - Delete',
      params,
    }),
};

export { orderSchoolsApi };
export default orderSchoolsApi;
